import { defaultLocale, type Locale } from "@/lib/i18n/locales";
import { localizedPath } from "@/lib/i18n/navigation";

export const SITE_ORIGIN = "https://www.solving.legal";

/**
 * Regional/locale tag for Open Graph and similar APIs (e.g. de_DE, en_US).
 */
export function localeToRegionalTag(locale: Locale): string {
  switch (locale) {
    case "de":
      return "de_DE";
    case "en":
      return "en_US";
    case "fr":
      return "fr_FR";
    case "zh":
      return "zh_CN";
    case "ja":
      return "ja_JP";
    default:
      return "de_DE";
  }
}

/** hreflang value (BCP 47 / Google). */
export function localeToHreflang(locale: Locale): string {
  return locale === "zh" ? "zh-Hans" : locale;
}

export function absoluteUrlForLocalePath(
  locale: Locale,
  innerPath: string,
): string {
  const path = localizedPath(innerPath === "/" ? "/" : innerPath, locale);
  return `${SITE_ORIGIN}${path}`;
}

/**
 * Next.js `alternates.languages` map: hreflang -> absolute URL.
 * Only includes `x-default` when German is in the set.
 */
export function languageAlternatesForLocales(
  innerPath: string,
  availableLocales: readonly Locale[],
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const loc of availableLocales) {
    out[localeToHreflang(loc)] = absoluteUrlForLocalePath(loc, innerPath);
  }
  if (availableLocales.includes(defaultLocale)) {
    out["x-default"] = absoluteUrlForLocalePath(defaultLocale, innerPath);
  }
  return out;
}
